import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import * as moment from 'moment';

@Injectable()
export class DateTimeUtils {

  // tslint:disable-next-line:no-empty
  constructor() { }

  public static dateLabel(date: Date, filter: any): string {
    let prefix: string = filter.range.toUpperCase();

    if (prefix == 'FY') {
      prefix = 'Last Updated';
    } else if (filter && filter.psd) {
      let psd: string = filter.psd;
      if (psd.charAt(0) == '-') {
        // tslint:disable-next-line:max-line-length
        prefix = 'Past ' + psd.charAt(1) + ' ' + (psd.charAt(2) === 'W' ? 'Weeks' : 'Months') + ' as ';
      }
    // tslint:disable-next-line:quotemark
    } else if (prefix == "DAY") {
      prefix = "";
    } else {
      prefix += ' as ';
    }

    return prefix.concat(' on ').concat(moment(date).format('DD MMM YYYY'));
  }

  public static relativeDate(filter: any, oper: string): void {
    try {
      let ped: Date = this.fromymd(filter.ped);

      let period: string = oper.charAt(0);
      let operand = oper.charAt(1).toUpperCase();
      let count = oper.charAt(2);

      let base_date = moment(ped);
      let to_date: any;
      let from_date: any;

      // TODO make M dynamic
      if (operand == '-') {
        to_date = moment(ped).subtract(count, 'M');
      } else {
        to_date = moment(ped).add(count, 'M');
      }
      filter.fped = to_date.format('YYYYMMDD');

      from_date = to_date.startOf('M');
      filter.fsed = from_date.format('YYYYMMDD');

    } catch (e) {
      console.error(e);
    }
  }

  public static toymd(date: Date): string {
    return moment.utc(date).format('YYYYMMDD');
  }

  public static toDate(date: string): Date {
    return moment.utc(date, 'YYYYMMDD').toDate();;
  }

  public static formatDate(date: Date): string {
    return moment.utc(date).format('MM/DD/YYYY');
  }

  public static fromymd(date: string): any {
    return moment.utc(date, 'YYYYMMDD');
  }

  public static strToIMyDate(item: string): any {
    return this.dateToIMyDate(DateTimeUtils.toDate(item));
  }

  public static dateToIMyDate(curr: Date): any {
    return {
      year: curr.getFullYear(),
      month: curr.getMonth() + 1,
      day: curr.getDate()
    };
  }

  public static intToIMyDate(curr: string): any {
    return {
      year: parseInt(curr.substring(0, 4)),
      month: parseInt(curr.substring(4, 6)),
      day: parseInt(curr.substring(6, 8))
    };
  }

  public static imyDateToInt(curr: any): any {
    if (curr && !!curr.year) {
      return Number(curr.year + this.padLeft(curr.month, '0', 2) + this.padLeft(curr.day, '0', 2));
    } else {
      return Number(moment.utc(new Date()).format('YYYYMMDD'));
    }
  }

  public static imyDateToDate(curr: any): any {
    // if (curr && !isNaN(curr.year)) {
    if (curr && !!curr.year) {
      return curr.year + '-' + this.padLeft(curr.month, '0', 2) + '-' + this.padLeft(curr.day, '0', 2);
    } else {
      return moment.utc(new Date()).format('YYYY-MM-DD');
    }
  }

  static padLeft(text: string, padChar: string, size: number): string {
    return (String(padChar).repeat(size) + text).substr((size * -1), size);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/date-utils.ts